import {Home} from "./pages/home.jsx"

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
